import { render, staticRenderFns } from "./fa-tag.vue?vue&type=template&id=470377bb&"
import script from "./fa-tag.vue?vue&type=script&lang=js&"
export * from "./fa-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports